import {faReceipt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import gql from 'graphql-tag';
import 'moment/locale/fr';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {withApollo} from 'react-apollo';
import {withTranslation} from 'react-i18next';
import StarRatings from 'react-star-ratings';
import styled from 'styled-components';
import {dateFormatFR} from '../../../utils';
import DataTable from '../../../common/components/Datatable/Datatable';
import DisplayTag from '../../../common/components/DisplayTag';
import Screen from '../../../common/components/layout/Screen';
import Metadata from '../../../common/components/Metadata';
import {FILTER_EXPRESSION_OPERATOR, FILTER_OPERATOR, ORDER_DIRECTION} from '../../../common/constants';
import AddReceiptUser from '../../ticket/components/AddReceiptUser';
import RowActionReceiptUser from './RowActionReceiptUser';
import DisplayBoolean from '../../../common/components/DisplayBoolean';
import DateRangePicker from '../../../common/components/Dates/DateRangePicker';
import {Col, Row} from 'react-bootstrap';
import moment from 'moment';
import isAfterDay from 'react-dates/lib/utils/isAfterDay';
import SelectReceiptIsPro from '../../../common/components/SelectReceiptIsPro';


const GRAPHQL_QUERY_TICKETS_LIST = gql`
  query ticketsList($criteria: CriteriaInput!) {
    currentUser {
      id
      receipts(criteria: $criteria) {
        id
        total
        rows {
          id
          createdAt
          isPro
          brand {
            id
            name
            file {
              id
              key
              token
            }
          }
          rating
          comments {
            id
            createdAt
            review
            user {
              id
              firstName
              lastName
            }
          }
          tags {
            id
            total
            rows {
              id
              name
            }
          }
          file {
            id
            key
            token
            filename
            mimeType
          }
          merchant{
            id
            businessName
            contactEmail
            phoneNumber
            user{
              id
              firstName
              lastName
              city
              postalCode
            }
          }
        }
      }
    }
  }
`;

const MargedDiv = styled.div`
  margin-right: 15px;
`;


const Span = styled.span`
  font-family: 'Segoe UI Bold', sans-serif;
`;

class TicketViewUser extends Component {

  state = {
    search: '',
    startDate: null,
    endDate: null,
    isPro: 'default',
  };

  columns = t => [
    {
      Header: '#',
      accessor: 'id',
    },
    {
      Header: t('brand'),
      accessor: 'brand.name',
      sortable: true,
    },
    {
      Header: t('dataTable.creation'),
      Cell: ({cell}) => dateFormatFR({date: cell.value}),
      accessor: 'createdAt',
      sortable: true,
    },
    {
      Header: t('dataTable.note'),
      Cell: ({cell}) => this.displayRating(cell.value),
      accessor: 'rating',
      sortable: true,
    },
    {
      Header: t('dataTable.comment'),
      Cell: ({cell}) => this.displayReviewStatus(cell.value),
      accessor: 'comments[0]',
    },
    {
      Header: t('dataTable.commentReply'),
      Cell: ({cell}) => this.displayReviewStatus(cell.value),
      accessor: 'comments[1]',
    },
    {
      Header: t('dataTable.isPro'),
      Cell: ({cell}) => <DisplayBoolean bool={cell.value}/>,
      accessor: 'isPro',
    },
    {
      Header: t('dataTable.tags'),
      Cell: ({cell}) => this.displayTags(cell.value),
      accessor: 'tags',
    },
    {
      Header: t('detail'),
      Cell: ({cell}) => this.displayAction(cell.value),
      accessor: row => row,
    },
  ];

  createFilters = (search, startDate, endDate, isPro) => {

    const andFilters = [];
    const startObject = {
      field: 'receipt.createdAt',
      operator: FILTER_OPERATOR.GreaterThan,
      value: startDate,
    };
    const endObject = {
      field: 'receipt.createdAt',
      operator: FILTER_OPERATOR.LessThan,
      value: endDate,
    };

    const isProFilterObject = {
      field: 'receipt.isPro',
      operator: FILTER_OPERATOR.Equal,
      value: isPro,
    };

    if (startDate) {
      andFilters.push(startObject);
    }
    if (endDate) {
      andFilters.push(endObject);
    }

    if (isPro !== 'default' && isPro !== 'all') {
      andFilters.push(isProFilterObject);
    }

    return {
      operator: FILTER_EXPRESSION_OPERATOR.And,
      expressions: [
        {
          operator: FILTER_EXPRESSION_OPERATOR.And,
          filters: andFilters,
        },
        {
          operator: FILTER_EXPRESSION_OPERATOR.Or,
          filters: [
            {
              field: 'receipt.id',
              operator: FILTER_OPERATOR.Like,
              value: `%${search}%`,
            }, {
              field: 'brand.name',
              operator: FILTER_OPERATOR.Like,
              value: `%${search}%`,
            },
          ],
        },
      ],
      relations: ['brand'],
    };
  };

  displayTags = (data) => {
    return (
      <div>
        {data.rows.map((tag, index) => (
          <DisplayTag key={index} tag={tag}/>
        ))}
      </div>
    );
  };

  displayAction = (row) => {
    return (
      <RowActionReceiptUser receipt={row}/>
    );
  };

  displayRating = (data) => {
    return (
      data ?
        <StarRatings
          rating={data !== null ? data : 0}
          starDimension="20px"
          starSpacing="3px"
          starRatedColor='#C90164'
        /> : null
    );
  };

  displayReviewStatus = data => {
    return (
      <DisplayBoolean bool={data !== undefined}/>
    );
  };

  isOutsideDateRange = (day) => {
    let dayIsBlocked = false;
    if (isAfterDay(day, moment())) {
      dayIsBlocked = true;
    }
    return dayIsBlocked;
  };

  handleChangeDate = (startDate, endDate) => {
    this.setState({
      startDate,
      endDate,
    });
  };

  render() {
    const {t} = this.props;

    const DatePickerContainer = styled.div`
      margin-right: 15px;
    `;


    const additionalFilters = (
      <>
        <DatePickerContainer>
          <DateRangePicker
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            isOutsideRange={this.isOutsideDateRange}
            onDatesChange={({startDate, endDate}) => this.handleChangeDate(startDate, endDate)}/>
        </DatePickerContainer>
        <MargedDiv>
          <SelectReceiptIsPro
            value={this.state.isPro}
            onChange={e => {
              this.setState({isPro: e.target.value});
            }}
          />
        </MargedDiv>
      </>
    );

    return (
      <Screen
        header={<Metadata meta={t('meta')} title={t('title')}/>}
        leftTitle={
          <>
            <FontAwesomeIcon icon={faReceipt} color={'rgb(201,0,95)'}/>
            <Span className="route-name">{t('TicketViewUser.title')}</Span>
          </>
        }
        rightTitle={<AddReceiptUser/>}>
        <Row>
          <Col xs={12}>
            <DataTable
              query={GRAPHQL_QUERY_TICKETS_LIST}
              keyResult="currentUser.receipts"
              columns={this.columns(t)}
              onSearch={value => this.setState({search: value})}
              advancedFilters={this.createFilters(
                this.state.search,
                this.state.startDate,
                this.state.endDate,
                this.state.isPro,
              )}
              additionalFilters={additionalFilters}
              defaultSort={{field: 'createdAt', direction: ORDER_DIRECTION.DESC}}/>
          </Col>
        </Row>
      </Screen>
    );
  }
}

TicketViewUser.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withApollo(withTranslation('ticket')(TicketViewUser));
